import { CORE } from '../constants/globals';
import { coreConstructionToStr, coreToString } from '../lib/material';
import CoreView from '../components/common/materials/Core';
import Resin, { sanitize } from './Resin';

export class Core extends Resin{
  constructor(resin){
    super(sanitize(resin));

    // These properties intended not to be changed once set
    this.type          = CORE;
    this.view          = CoreView.displayName;

    this._color = resin.color;
  }

  update(resin) {
    return Object.assign(this, {
      _color: resin.material ? resin.material.color : this.color,
      name: resin.name || this.name,
      _material: resin.material ? sanitize(resin.material) : this._material 
    });
  }

  get thickness() {
    return this.material.thickness;
  }

  get product() {
    return this.material.product;
  }

  get manufacturer() {
    return this.material.manufacturer;
  }

  get manufacturerId() {
    return this.material.manufacturerId;
  }

  get resinId() {
    return this.material.resinId;
  }

  get construction() {
    return this.material ?
      coreConstructionToStr(this.material) :
      'N/A';
  }

  get dk() {
    return this.material.dk;
  }

  get df() {
    return this.material.df;
  }

  get spaceNeeded() {
    return this.thickness_px;
  }

  get resinContentPercent() {
    return this.material.resinContent ? this.material.resinContent * 100 : undefined;
  }

  toString(unit) {
    return coreToString(this.material, unit);
  }
}

export const anonymousCore = () => new Core({ thickness: 0.0015, color: 0xff0000 });

export default Core;


// WEBPACK FOOTER //
// ./src/models/Core.js